export default __webpack_public_path__ + "static/DEIPage-pattern-medium-blue-85758be3f8e59fe4209ed0287a582ddb.png";